import MenuIcon from './MenuIcon';
import MenusTranslation from './MenusTranslation';
export default class Menu {
    constructor(menus) {
        const { id, status, slug, menu_type, parent, color_class, internal_link, show_sitemap, is_route, menu_icon, translations, submenus } = menus;
        this.id = id;
        this.slug = slug;
        this.status = status;
        this.menu_type = menu_type;
        this.parent = parent ? new Menu(parent) : undefined;
        this.color_class = color_class !== null && color_class !== void 0 ? color_class : '';
        this.menu_icon = menu_icon ? new MenuIcon(menu_icon) : undefined;
        this.internal_link = internal_link;
        this.show_sitemap = show_sitemap;
        this.is_route = is_route;
        this.submenus = submenus ? submenus.map(submenu => new Menu(submenu)) : [];
        this.translations = translations
            ? translations.map(translation => new MenusTranslation(translation))
            : [];
    }
}
